import {NgModule} from '@angular/core';
import {ProductRetrocessionConverter} from './api/entity/converter/productRetrocession.converter';
import {ProductRetrocessionRepository} from './impl/service/ngrx/productRetrocession.repository';
import {ProductRetrocessionDataService} from './impl/service/ngrx/productRetrocessionData.service';
import {ProductRetrocessionDataServiceAdapter} from './impl/service/ngrx/productRetrocessionDataService.adapter';
import {EntityDataService, EntityServices} from '@ngrx/data';
import {ProductRetrocessionRuleConverter} from './api/entity/converter/productRetrocessionRule.converter';
import {
    ProductRetrocessionRetrocessionConverter
} from './api/entity/converter/productRetrocessionRetrocession.converter';
import {errorMessages} from "../../core/error/errorMessages";

@NgModule({
    providers: [
        ProductRetrocessionRepository,
        ProductRetrocessionDataService,
        ProductRetrocessionDataServiceAdapter,

        ProductRetrocessionConverter,
        ProductRetrocessionRuleConverter,
        ProductRetrocessionRetrocessionConverter,
    ],
})
export class ProductRetrocessionModule {
    constructor(entityDataService: EntityDataService,
                entityServices: EntityServices,
                service: ProductRetrocessionRepository,
                dataService: ProductRetrocessionDataService,
    ) {

        entityDataService.registerServices({
            ProductRetrocession: dataService,
        });

        entityServices.registerEntityCollectionServices({
            ProductRetrocession: service,
        });

        errorMessages.set('PRODUCT_RETROCESSION_SAVE_RULE_USERS_CANNOT_BE_THE_SAME', 'Les 2 personnes impliquées dans la règle ne peuvent pas être les mêmes.');
    }
}
